// extracted by mini-css-extract-plugin
module.exports = {"downloadPdf":"Download_downloadPdf__2ZY6b","buttonPlacement":"Download_buttonPlacement__1ygfU","active":"Download_active__1Q0pM"};